import {
  Button,
  ButtonGroup,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  IconLucide,
  cn
} from '@yakit/ui-components';

import { useVDLStore } from '@VDL/store/VDLstore';

import type { IYear } from '@VDL/api/types/IYear';

export const VDLYearsButtons = ({ className }: { className?: string }) => {
  const { yearList, setSelectedYear, selectedYear } = useVDLStore();

  const handleClickYearButton = (yearObject: IYear) => {
    const numberYear = parseInt(yearObject.code);

    setSelectedYear(numberYear);
  };

  return (
    <>
      {yearList.length > 0 && (
        <>
          <ButtonGroup<IYear>
            className={cn('hidden md:inline-flex', className)}
            listForButtons={yearList}
            renderButton={(yearObject) => (
              <Button
                key={yearObject.code}
                onClick={() => handleClickYearButton(yearObject)}
                variant="outline"
                size="sm"
                className={cn({
                  'border-primary bg-primary text-secondary hover:bg-primary/90 hover:text-accent':
                    selectedYear === parseInt(yearObject.code)
                })}
              >
                {yearObject.name}
              </Button>
            )}
          />
          <DropdownMenu>
            <DropdownMenuTrigger className="md:hidden" asChild>
              <Button className={cn('group', className)} variant="outline">
                {selectedYear}
                <IconLucide
                  name="ChevronDown"
                  className="ml-2 h-4 w-4 group-data-[state=open]:rotate-180"
                />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              {yearList.map((yearObject) => (
                <DropdownMenuCheckboxItem
                  key={yearObject.code}
                  checked={parseInt(yearObject.code) === selectedYear}
                  onCheckedChange={() =>
                    setSelectedYear(parseInt(yearObject.code))
                  }
                >
                  {yearObject.name}
                </DropdownMenuCheckboxItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      )}
    </>
  );
};
